import icons from "../../../../../Data/icons";

import classes from "./addCompanies.module.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  ClassicEditor,
  Bold,
  Essentials,
  Italic,
  Mention,
  Paragraph,
  Undo,
  Heading,
  Highlight,
  Image,
  ImageCaption,
  ImageResize,
  ImageStyle,
  ImageToolbar,
  LinkImage,
  FontSize,
  FontFamily,
  FontBackgroundColor,
  FontColor,
  BlockQuote,
  Underline,

  
} from "ckeditor5";
import "ckeditor5/ckeditor5.css";
const EditPages = ({
  setActive,
  active,
  name,
  description,
  setDescription,
  app,
  setApp,
  menu,
  setMenu,
  setName,
}) => {
  const Abc = icons.abc;
  const Desc = icons.description;

  const handleNameChange = (e) => {
    setName(e.target.value);
  };
  const handleDesChange = (e) => {
    const newcontent = e.editor.getData()
    setDescription(newcontent);
  };
  const handleAppChange = (e) => {
    const isChecked = e.target.checked;
    setApp(isChecked ? 1 : 0);
  };
  const handleMenuChange = (e) => {
    const isChecked = e.target.checked;
    setMenu(isChecked ? 1 : 0);
  };

  const handleActiveChange = (e) => {
    const isChecked = e.target.checked;
    setActive(isChecked ? 1 : 0);
  };

  return (
    <div className={classes.formCard}>
      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">اسم الصفحة</label>
          <div className={classes.iconInput}>
            <Abc />
          </div>
          <input
            type="text"
            placeholder="ادخل اسم الصفحة"
            value={name}
            onChange={handleNameChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">الوصف </label>
          <CKEditor
            editor={ClassicEditor}
            config={{
              toolbar: {
                items: [
                  "undo",
                  "redo",
                  "|",
                  "bold",
                  "italic",
                  "Underline",
                  "FontSize",
                  "FontFamily",
                  "FontColor",
                  "Paragraph",
                  "Heading",                
                  "BlockQuote",
                  "LinkImage",
                  "ImageCaption",
                  "ImageResize",
                  "ImageStyle",
                  "ImageToolbar",
            
            
                ],
              },
              plugins: [
                Bold,
                Essentials,
                Italic,
                Mention,
                Paragraph,
                Undo,
                Heading,
                Highlight,
                Image,
                ImageCaption,
                ImageResize,
                ImageStyle,
                ImageToolbar,
                LinkImage,
                FontSize,
                FontFamily,
                FontBackgroundColor,
                FontColor,
                BlockQuote,
                Underline,
             
              ],
              licenseKey: "<YOUR_LICENSE_KEY>",
              mention: {
                // Mention configuration
              },

              initialData: "<p>الوصف </p>",
            }}
            //   onReady={ ( editor ) => {
            //     if ( editorToolbarRef.current ) {
            //         editorToolbarRef.current.appendChild( editor.ui.view.toolbar.element );
            //     }
            // }}
           data={description}
            events={{
              change: handleDesChange,
            }}
            
            />
        </div>
        <div className={classes.formCol}>
          <label
            htmlFor="active"
            className={active ? `${classes.active}` : `${classes.disActive}`}>
            {" "}
            {active === 1 ? " نشط" : "غير نشط"}{" "}
          </label>

          <label class="switch">
            <input
              type="checkbox"
              onChange={handleActiveChange}
              checked={active}
            />
            <span class="slider round"></span>
          </label>
        </div>
        <div className={classes.formCol}>
          <label
            htmlFor="active"
            className={active ? `${classes.active}` : `${classes.disActive}`}>
            {" "}
            {menu === 1 ? " قائمة" : "ليست قائمة"}{" "}
          </label>

          <label class="switch">
            <input type="checkbox" onChange={handleMenuChange} checked={menu} />
            <span class="slider round"></span>
          </label>
        </div>
        <div className={classes.formCol}>
          <label
            htmlFor="active"
            className={app ? `${classes.active}` : `${classes.disActive}`}>
            {" "}
            {app === 1 ? " ابلكيشن" : " ليس ابلكيشن"}{" "}
          </label>

          <label class="switch">
            <input type="checkbox" onChange={handleAppChange} checked={app} />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default EditPages;
